import { Stack } from '@mui/material';
import { ApprovalsProvider } from './Approvals.provider';
import ConfirmationDialog from './components/ConfirmationDialog';
import Filter from './components/Filter';
import Header from './components/Header';
import SnackBars from './components/SnackBars';
import Table from './components/Table';

export default function Approvals() {
  return (
    <ApprovalsProvider>
      <Stack gap={2} p={3}>
        <Stack gap={3}>
          <Header />
          <Filter />
        </Stack>
        <Table />
      </Stack>
      <ConfirmationDialog />
      <SnackBars />
    </ApprovalsProvider>
  );
}
